type DataOverride = [number, number];

export default function filterDuplicatesDataOverride(
	oldData: DataOverride[] | undefined,
	newData: DataOverride[],
) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const newTimestampsWithValues = newData.filter(([_, value]) => !!value);
	const newTimestampsSet = new Set(
		newTimestampsWithValues.map(([timestamp]) => timestamp),
	);
	const oldWithoutNews = (oldData || []).filter(
		([timestamp]) => !newTimestampsSet.has(timestamp),
	);
	return [...oldWithoutNews, ...newTimestampsWithValues].sort(
		([timestamp1], [timestamp2]) => timestamp1 - timestamp2,
	);
}
